import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Nav from '../components/Nav';

import Footer from '../components/Footer';

const FAQ_DATA = [
  { q: 'Comment se passe le paiement ?', a: "Je demande 50% à la commande et 50% à la livraison des fichiers finaux. Les paiements se font par virement bancaire ou PayPal. Un contrat est signé avant le démarrage de chaque projet." },
  { q: 'Combien de temps dure un projet ?', a: "Un projet d'identité visuelle prend généralement entre 1 et 6 semaines selon la complexité et la formule choisie. Je vous fournis un planning détaillé avec des jalons clairs dès le démarrage." },
  { q: 'Que comprend exactement une "révision" ?', a: "Une révision correspond à un cycle de retours envoyés par e-mail ou via un outil de collaboration (Figma, Notion). Je rassemble tous vos commentaires en une seule fois pour avancer efficacement et éviter les allers-retours infinis." },
  { q: "Je suis à l'étranger, pouvez-vous quand même travailler avec moi ?", a: "Absolument. Je travaille en remote avec des clients partout en Europe et au-delà. La communication se fait par e-mail, Discord ou vidéo selon vos préférences. La distance n'a jamais été un obstacle." },
  { q: 'Je reste propriétaire des fichiers créés ?', a: "Oui, à 100%. Une fois le projet réglé, vous recevez la pleine propriété intellectuelle de tous les éléments créés, ainsi que tous les fichiers sources selon la formule choisie. Aucune restriction d'usage." },
  { q: 'Ces tarifs sont-ils négociables ?', a: "Les tarifs affichés sont des bases indicatives. Pour les associations, les startups en early-stage ou les projets de longue durée, des arrangements sont possibles. Contactez-moi pour en discuter librement." },
];

const COMPARE_ROWS = [
  { label: 'Logo principal',              ess: '✓',           pro: '✓',              prem: '✓',           proCheck: true, essCheck: true, premCheck: true },
  { label: 'Variantes du logo',           ess: '2',           pro: 'Illimitées',     prem: 'Illimitées' },
  { label: 'Cycles de révisions',         ess: '2',           pro: 'Illimitées',     prem: 'Illimitées' },
  { label: 'Charte graphique',            ess: '✗',           pro: '20 pages',       prem: '40 pages',    essCross: true },
  { label: 'Kit réseaux sociaux',         ess: '✗',           pro: '6 formats',      prem: 'Complet',     essCross: true },
  { label: 'Fichiers sources (.ai / .fig)',ess: '✗',           pro: '✓',              prem: '✓',           essCross: true, proCheck: true, premCheck: true },
  { label: "Guide d'utilisation",         ess: '✗',           pro: '✗',              prem: '40 pages',    essCross: true, proCross: true },
  { label: 'Délai estimé',               ess: '1 – 2 sem.',  pro: '2 – 4 sem.',     prem: '4 – 6 sem.' },
  { label: 'Propriété intellectuelle',    ess: '✓',           pro: '✓',              prem: '✓',           essCheck: true, proCheck: true, premCheck: true },
];

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`faq-item${open ? ' open' : ''}`}>
      <button className="faq-q" onClick={() => setOpen(!open)}>
        {q}
        <span className="faq-icon">+</span>
      </button>
      <div className="faq-a">{a}</div>
    </div>
  );
}

function CellVal({ val, isCheck, isCross }) {
  if (isCheck) return <span className="check">✓</span>;
  if (isCross) return <span className="cross">×</span>;
  return <>{val}</>;
}

export default function Tarification() {
  useEffect(() => { document.title = 'Tarification — HEYIMPURP'; }, []);

  return (
    <>
      <Nav />
      <div className="tarif-page-header">
        <div>
          <div className="page-label">Investissement</div>
          <h1 className="page-title">TARIFI-<br />CATION</h1>
        </div>
        <div className="page-right">
          <p className="page-subtitle" style={{ marginBottom: 24 }}>Des formules pensées pour chaque type de projet. Transparence totale, zéro mauvaise surprise. Chaque devis est adapté à vos besoins réels.</p>
          <div className="page-note">Réponse sous <span>24h</span> — Devis gratuit</div>
        </div>
      </div>

      {/* CARDS */}
      <section className="pricing-section">
        <div className="pricing-grid">
          {/* ESSENTIEL */}
          <div className="pricing-card">
            <div className="card-num">Formule 01</div>
            <div className="card-name">ESSENTIEL</div>
            <div className="card-price">
              <span className="price-currency">€</span>
              <span className="price-amount">150</span>
              <span className="price-label">/ projet<br />estimé</span>
            </div>
            <ul className="card-features">
              <li><span className="feat-icon yes">✓</span> Logo principal + 2 variantes</li>
              <li><span className="feat-icon yes">✓</span> Palette de couleurs &amp; typographies</li>
              <li><span className="feat-icon yes">✓</span> Fichiers livrés (SVG, PDF, PNG)</li>
              <li><span className="feat-icon yes">✓</span> 2 cycles de révisions</li>
              <li className="off"><span className="feat-icon no">×</span> Kit réseaux sociaux</li>
              <li className="off"><span className="feat-icon no">×</span> Charte graphique complète</li>
              <li className="off"><span className="feat-icon no">×</span> Fichiers sources (.ai / .fig)</li>
            </ul>
            <Link to="/contact" className="card-btn card-btn-outline">Démarrer →</Link>
          </div>

          {/* PROFESSIONNEL */}
          <div className="pricing-card featured">
            <div className="card-num">Formule 02</div>
            <div className="card-name">PROFESSIONNEL</div>
            <div className="card-price">
              <span className="price-currency">€</span>
              <span className="price-amount">350</span>
              <span className="price-label">/ projet<br />estimé</span>
            </div>
            <ul className="card-features">
              <li><span className="feat-icon yes">✓</span> Logo + variantes complètes</li>
              <li><span className="feat-icon yes">✓</span> Charte graphique complète (10p.)</li>
              <li><span className="feat-icon yes">✓</span> Tous formats de fichiers</li>
              <li><span className="feat-icon yes">✓</span> Révisions illimitées</li>
              <li><span className="feat-icon yes">✓</span> Kit réseaux sociaux (6 formats)</li>
              <li><span className="feat-icon yes">✓</span> Fichiers sources inclus</li>
              <li className="off"><span className="feat-icon no">×</span> Guide d'utilisation 40p.</li>
            </ul>
            <Link to="/contact" className="card-btn card-btn-filled">Choisir cette formule →</Link>
          </div>

          {/* PREMIUM */}
          <div className="pricing-card">
            <div className="card-num">Formule 03</div>
            <div className="card-name">PREMIUM</div>
            <div className="card-price">
              <span className="price-currency">€</span>
              <span className="price-amount">550</span>
              <span className="price-label">/ projet<br />estimé</span>
            </div>
            <ul className="card-features">
              <li><span className="feat-icon yes">✓</span> Identité visuelle complète</li>
              <li><span className="feat-icon yes">✓</span> Charte graphique premium (20p.)</li>
              <li><span className="feat-icon yes">✓</span> Tous formats + sources</li>
              <li><span className="feat-icon yes">✓</span> Révisions illimitées</li>
              <li><span className="feat-icon yes">✓</span> Kit complet digital &amp; print</li>
              <li><span className="feat-icon yes">✓</span> Fichiers sources inclus</li>
              <li><span className="feat-icon yes">✓</span> Guide d'utilisation 40p.</li>
            </ul>
            <Link to="/contact" className="card-btn card-btn-outline">Démarrer →</Link>
          </div>
        </div>
      </section>

      {/* COMPARE */}
      <section className="compare-section">
        <h2 className="compare-title">COMPARATIF DÉTAILLÉ</h2>
        <table className="compare-table">
          <thead>
            <tr>
              <th>Fonctionnalité</th>
              <th>Essentiel</th>
              <th className="featured-col">Professionnel</th>
              <th>Premium</th>
            </tr>
          </thead>
          <tbody>
            {COMPARE_ROWS.map((row, i) => (
              <tr key={i}>
                <td>{row.label}</td>
                <td><CellVal val={row.ess} isCheck={row.essCheck} isCross={row.essCross} /></td>
                <td className="featured-col"><CellVal val={row.pro} isCheck={row.proCheck} isCross={row.proCross} /></td>
                <td><CellVal val={row.prem} isCheck={row.premCheck} isCross={row.premCross} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      {/* CUSTOM BAND */}
      <div className="custom-band">
        <div className="custom-band-left">
          <h3>PROJET SUR<br />MESURE ?</h3>
          <p>Votre besoin ne rentre pas dans une case ? Motion design, direction artistique longue durée, retainer mensuel — parlons-en et je construis un devis taillé pour vous.</p>
        </div>
        <Link to="/contact" className="btn-primary">Demander un devis →</Link>
      </div>

      {/* FAQ */}
      <section className="faq-section">
        <div>
          <div className="faq-section-label">Questions</div>
          <h2 className="faq-section-title">FAQ</h2>
          <p className="faq-section-sub">Tout ce que vous devez savoir avant de démarrer un projet.</p>
        </div>
        <div>
          {FAQ_DATA.map((item, i) => <FaqItem key={i} {...item} />)}
        </div>
      </section>

      <Footer />
    </>
  );
}
